import { render } from "./FoodSurplusData.vue?vue&type=template&id=7e56d957&scoped=true"
import script from "./FoodSurplusData.vue?vue&type=script&lang=js"
export * from "./FoodSurplusData.vue?vue&type=script&lang=js"

import "./FoodSurplusData.vue?vue&type=style&index=0&id=7e56d957&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e56d957"]])

export default __exports__